import { BrowserModule } from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { NgModule, LOCALE_ID, NO_ERRORS_SCHEMA } from '@angular/core';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {FormsModule} from '@angular/forms';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { ToastModule } from 'primeng/toast';
import { MultiSelectModule } from 'primeng/multiselect';
import { MessageService } from 'primeng/api';
import { ApiService } from './app.service';
import { randomDelay } from './app.directive';

import { AppComponent } from './app.component';
import { registerLocaleData  } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { IntroComponent } from './intro/intro.component';
import { MapComponent } from './map/map.component';
import { PizzasComponent } from './pizzas/pizzas.component';
registerLocaleData(localeFr);

@NgModule({
	declarations: [
		randomDelay,
		AppComponent,
		IntroComponent,
		MapComponent,
		PizzasComponent,
	],
	imports: [
	BrowserModule,
	BrowserAnimationsModule,
	HttpClientModule,
	FormsModule,
	LeafletModule.forRoot(),
	DialogModule,
	ButtonModule,
	CardModule,
	ToastModule,
	MultiSelectModule,
	],
	providers: [
	ApiService,
	MessageService,
    {provide: LOCALE_ID, useValue: 'fr-FR' }
	],
	bootstrap: [AppComponent],
	schemas: [ NO_ERRORS_SCHEMA ]

})
export class AppModule { }
